<template>
    <page>
        <module enable-flex ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
                    <c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone"></c-form-item>
					          <c-form-item type="input" label="上级代理手机" name="leader_user_manage_mobilephone"></c-form-item>
                    <c-form-item type="select" label="代理等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="checkbox" label="会员状态" name="state" :options="stateType"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="black" hollow @click="backHigher" v-if="higherLevel.platform_user_id">返回</c-button>
                <span v-if="higherLevel.platform_user_id"
                      style="margin-left: 10px; font-size: 13px;">上级：{{ `${higherLevel.nick_name}(${higherLevel.user_manage_mobilephone})` }}</span>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <!--右侧通用菜单-->
                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">
                        编辑导出列
                    </c-button>
                </template>
            </m-operate>
            <c-table ref="table">
                <c-table-column type="selector" ></c-table-column>

				<c-table-column
				    label="代理头像/昵称/等级"
				    name="head_photo"
				    width="200"
				>
				    <template v-slot="{data}">
				        <div class="flex-center-cross">
							<c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{data.nick_name}}</span></br>
								<span style="color:blue">{{data.user_level_name}}</span>
							</div>
				        </div>
				    </template>
				</c-table-column>
				
                <c-table-column label="代理手机号" name="user_manage_mobilephone" width="120">
                    <template v-slot="{data}">
                        <a v-if="data.user_level > 0 && data.direct_count > 0" class="s-link"
                           @click="loadLower(data)">
                            ↓ {{ data.user_manage_mobilephone }}
                        </a>
                        <span v-else>{{ data.user_manage_mobilephone }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="邀请人" name="share_user_manage_mobilephone" width="200">
					<template v-slot="{data}">
                		<span v-if="data.platform_user_id == -1" style="color:#bbb">-</span>
                		<div class="flex-center-cross" v-else>
							<c-image :src="data.share_user_head_photo" preview size="55" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{data.share_user_manage_mobilephone||'-'}}</span><br/>
								<span style="color:blue">{{data.share_user_level_name||'-'}}</span><br/>
								<span>{{data.share_user_nick_name||'-'}}</span>
							</div>
                		</div>
					</template>
                </c-table-column>
                
                <c-table-column label="上级代理" name="leader_user_manage_mobilephone" width="200">
					<template v-slot="{data}">
                		<span v-if="!data.leader_user_level_name" style="color:#bbb">-</span>
                		<div class="flex-center-cross" v-else>
							<c-image :src="data.leader_user_head_photo" preview size="55" style="margin-right: 10px;"></c-image>
							<div>
								<span>{{data.leader_user_manage_mobilephone||'-'}}</span><br/>
								<span style="color:blue">{{data.leader_user_level_name||'-'}}</span><br/>
								<span>{{data.leader_user_nick_name||'-'}}</span>
							</div>
                		</div>
					</template>
                </c-table-column>
				
				<!-- <c-table-column
				    label="归属联创"
				    name="head_photo"
				    width="200"
				>
				    <template v-slot="{data}">
						<template v-if="data.platform_user_id != data.lc_user_id">
							<div class="flex-center-cross">
								<c-image :src="data.lc_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
								<div>
									<span>{{data.lc_nick_name}}</span></br>
									<span style="color:blue">{{data.lc_user_manage_mobilephone}}</span>
								</div>
							</div>
						</template>
						<span v-else style="color:#bbb">-</span>
				    </template>
				</c-table-column> -->
				
                <c-table-column
                        label="业绩数量"
                        name="performance_count"
                        width="100"
                >
                    <template v-slot="{data}">
                        <a v-if="data.performance_count > 0" style="color: blue" title="已结算业绩数量" @click="showPerformanceRecord(data,2)">{{data.performance_count}}</a>
                        <span v-else style="color: gray" title="已结算业绩数量">0</span>
                        /&nbsp;
                        <a v-if="data.unsettle_performance_count > 0" style="color: blue" title="待结算业绩数量" @click="showPerformanceRecord(data,1)">{{data.unsettle_performance_count}}</a>
                        <span v-else style="color: gray" title="待结算业绩数量">0</span>
                    </template>
                </c-table-column>
				<c-table-column
					label="货款余额(元)" name="account_balance" width="110">
					<template v-slot="{data}">
						￥{{(data.account_balance||0).toFixed(2)}}
					</template>
				</c-table-column>

                <c-table-column label="收益账户" name="account" width="110">
                    <template v-slot="{data}">
                        ￥{{ (data.reward_balance || 0).toFixed(2) }}
                    </template>
                </c-table-column>

                <c-table-column
                        label="积分"
                        name="points"
                        width="80"
                        v-if="systemConfig.points_system == 'ON'"
                >
                </c-table-column>

                <c-table-column label="直推代理数" name="direct_count" width="100">
                    <template v-slot="{data}">
                        <a v-if="data.user_level > 0 && data.direct_count > 0" class="s-link"
                           @click="loadLower(data)">
                            {{ data.direct_count }}&nbsp;↓&nbsp;
                        </a>
                        <span v-else>{{ data.direct_count }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="间推代理数" name="indirect_count" width="100">
                </c-table-column>
                <c-table-column label="状态" name="state" width="80">
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:red">禁用</span>
                        <span v-if="data.state == 1" style="color:green">启用</span>
                    </template>
                </c-table-column>
				<c-table-column label="加入代理时间" name="upgrade_date" width="150">
				</c-table-column>
                <c-table-column type="button" fixed="right" label="操作" width="150">
                    <template v-slot="{data}">
                        <c-table-button power="b_member_user_view_symx" @click="viewReward(data)"> 收益明细 </c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="$refs.memberUpgrade.open(data)">代理调整</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="showMemberUpgradeRecord(data)">调整记录</c-table-button>
						<c-table-button v-if="data.platform_user_id > 0" @click="showMemberParentList(data)">查看邀请链路</c-table-button>
                        <c-table-button power="b_member_edit_cloud_stock" v-if="systemConfig.cloud_stock == 'ON' && data.user_level >= systemConfig.cloud_stock_level"
                                        @click="setCloudStock(data)">云仓库存</c-table-button>
                        <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0 && data.group_user_count > 0" @click="$refs.memberMove.open(data)">成员转移</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
        <c-dialog ref="rewardDialog" title="收益明细" width="1200" height="800" enable-flex :button="false">
            <m-search ref="rewardSearch" @search="rewardSearchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardType">
                    </c-form-item>
                    <c-form-item type="checkbox" label="收益状态" name="state" :options="rewardState">
                    </c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
                    </c-form-item>
                </c-form>
            </m-search>
            <c-table ref="rewardTable" height="grow">
                <c-table-column label="单号" width="150" name="record_number">
                </c-table-column>
                <c-table-column label="收益类型" width="100" name="reward_type">
                    <template v-slot="{data}">
						<span v-if="data.reward_type==1">分销差价</span>
						<span v-if="data.reward_type==2">直推收益</span>
						<span v-if="data.reward_type==3">间推收益</span>
						<span v-if="data.reward_type==4">区代奖励</span>
						<span v-if="data.reward_type==22">平级奖励</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益金额" name="record_money" width="120">
                    <template v-slot="{data}">
                        <span v-if="data.state==0">￥{{ (data.estimated_record_money || 0).toFixed(2) }}</span>
                        <span v-if="data.state==1"><span
                                style="color:darkgray">[预估]</span>￥{{ (data.estimated_record_money || 0).toFixed(2) }}</span>
                        <span v-if="data.state==2">￥{{ (data.record_money || 0).toFixed(2) }}</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益状态" name="state" width="75">
                    <template v-slot="{data}">
						<span v-if="data.state==0">
							<span style="color:#aaaaaa">
								{{ rewardStateMap[data.state] }}
							</span>
						</span>
                        <span v-if="data.state==1">
							<span style="color:sandybrown">
								{{ rewardStateMap[data.state] }}
							</span>
						</span>
                        <span v-if="data.state==2">
							<span style="color:darkgreen">
								{{ rewardStateMap[data.state] }}
							</span>
						</span>
                    </template>
                </c-table-column>
                <c-table-column label="关联会员" name="nick_name" width="250">
                    <template v-slot="{data}">
                        {{ data.nick_name }}【{{ data.user_manage_mobilephone }}】
                    </template>
                </c-table-column>
                <c-table-column label="关联单号" name="relate_number" width="150">
                </c-table-column>
                <c-table-column label="商品原价" name="original_product_money" width="95">
                    <template v-slot="{data}">
						<span v-if="data.reward_type == 1 || data.reward_type == 5">
							￥{{ (data.original_product_money || 0).toFixed(2) }}
						</span>
                        <span v-else>
							--
						</span>
                    </template>
                </c-table-column>
                <c-table-column label="商品成交价" name="product_money" width="95">
                    <template v-slot="{data}">
						<span v-if="data.reward_type == 1">
							￥{{ (data.product_money || 0).toFixed(2) }}
						</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益时间" name="create_date" width="155">
                </c-table-column>
                <c-table-column label="到账时间" name="settlement_date" width="155">
                    <template v-slot="{data}">
                        {{ data.settlement_date || '--' }}
                    </template>
                </c-table-column>
                <c-table-column label="备注" name="remark" width="350">
                    <template v-slot="{data}">
                        {{ data.remark || '--' }}
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
        <!--云仓库存编辑-->
        <c-dialog ref="stockEdit" :title="stockEditTitle" width="1000" height="620" enable-flex  @resolve="setStockHandle">
            <m-search ref="stockSearch" @search="stockSearchHandle">
                <c-form ref="stockForm" inline>
                    <c-form-item type="input" label="商品信息" name="product_info" placeholder="模糊匹配货号、名称"></c-form-item>
                    <c-form-item type="input" label="商品规格" name="product_sku_spec" placeholder="模糊匹配商品规格"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
                    <c-form-item type="checkbox" label="" name="isStock" :options="[{name: '有库存',value: 1}]"></c-form-item>
                </c-form>
            </m-search>
            <c-table ref="stockTable" height="500">
                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="规格名称"
                        name="product_sku_spec"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="SKU编码"
                        name="product_sku_code"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="当前库存"
                        name="product_count"
                        width="70"
                >
                </c-table-column>

                <c-table-column
                        width="100"
                >
                    <template slot="head">
                        <div class="flex-center-cross">
                            <span>增减库存</span>
                            <a style="margin-left: 10px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
                        </div>
                    </template>
                    <template v-slot="{data}">
                        <c-input v-model="data.revise_stock" type="number" :limit="[-data.product_count, 9999]"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        label="调整后库存"
                        name="new_product_count"
                        width="120"
                >
                    <template v-slot="{data}">
                        {{parseInt(data.product_count) + (parseInt(data.revise_stock) || 0)}}
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
        <c-dialog ref="batchStockDialog" title="批量增/减库存" width="400" height="140" @resolve="batchSetStock">
            <c-form ref="batchStockForm">
                <c-form-item type="number" label="增/减库存" name="value"></c-form-item>
            </c-form>
        </c-dialog>
        <member-upgrade ref="memberUpgrade" @resolve="$refs.table.update()"></member-upgrade>
        <member-upgrade-record ref="memberUpgradeRecord"></member-upgrade-record>
        <user-performance-record ref="userPerformanceRecord"></user-performance-record>
		<member-parent-list ref="memberParentList"></member-parent-list>
		<member-move ref="memberMove" @resolve="$refs.table.update()"></member-move>
    </page>
</template>
<script>
import {mapState} from "vuex";
import productInfo from '@/components/public/product_info.vue'
import memberUpgradeRecord from '@/components/service/member_user_upgrade_record.vue'
import memberUpgrade from "@/components/service/member_user_upgrade.vue";
import userPerformanceRecord from "@/components/service/platform_user_performance_record.vue";
import memberParentList from "@/components/service/member_parent_list.vue";
import memberMove from "@/components/service/member_user_move.vue";

export default {
    name: 'm_member_user',

    components: {
        productInfo,
        memberUpgrade,
        memberUpgradeRecord,
        userPerformanceRecord,
		memberParentList,
		memberMove
    },

    data() {
        return {
            workType: 13,
            searchParams: {},
            rewardState: [
                {name: '已取消', value: 0},
                {name: '待到账', value: 1},
                {name: '已到账', value: 2}
            ],
            rewardStateMap: {
                '0': '已取消',
                '1': '待到账',
                '2': '已到账'
            },
            rewardType: [
                {name: '分销差价', value: 1},
				{name: '区代奖励', value: 4},
                {name: '平级奖励', value: 22}
            ],
            stateType: [
                {name: '启用', value: 1},
                {name: '禁用', value: 2}
            ],
            levelList: [],
            member_user_id: '',
            recommend_type: '',
            stockEditTitle:'云仓库存'
        }
    },

    computed: {
        ...mapState(['systemConfig', 'userInfo']),
        higherLevel() {
            return this.levelList[this.levelList.length - 1] || {};
        }
    },

    watch: {
        higherLevel(val) {
            this.$refs.search.clear();
            this.searchHandle();
        }
    },

    mounted() {
        this.$refs.search.search();
    },

    methods: {
        /*************显示代理调整日志配置**********/
        showMemberUpgradeRecord(data) {
            var title = '代理【' + data.user_manage_mobilephone + '(' + (data.nick_name || '--') + ')】调整记录';
            this.$refs.memberUpgradeRecord.open({
                platform_user_id: data.platform_user_id,
                title: title
            });
        },
		
		/*************查看会员邀请链路**********/
		showMemberParentList(data){
		  var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】邀请链路表';
		    this.$refs.memberParentList.open({
		        platform_user_id:data.platform_user_id,
		        title:title
		    });
		},

        viewReward(val) {
            this.$refs.rewardDialog.open();
            this.member_user_id = val.platform_user_id;
            this.$refs.rewardTable.load({
                url: '/member_user/reward/list',
                data: {
                    member_user_id: val.platform_user_id,
                }
            });
        },

        rewardSearchHandle(data) {
            data.member_user_id = this.member_user_id;
            this.$refs.rewardTable.load({
                url: '/member_user/reward/list',
                data
            });
        },

        searchHandle(data = {}) {
            data.member_user_id = this.higherLevel.platform_user_id;
            this.$refs.table.load({
                url: '/member_user/list',
                data
            });
            this.searchParams = data || {};
        },

        detail(val) {
            this.navigateTo({
                path: '/member_detail/' + val.platform_user_id,
            });
        },

        loadLower(data) {
            this.levelList.push(data);
        },

        backHigher() {
            this.levelList.splice(this.levelList.length - 1, 1);
        },

        //云仓库存弹窗
        setCloudStock(item) {
            this._setUserId = item.platform_user_id;
            this.stockEditTitle = '代理【'+item.user_manage_mobilephone+'】';
            if (item.nick_name){
                this.stockEditTitle += '('+item.nick_name+')';
            }
            this.stockEditTitle += ' - 云仓库存信息';
            this.$refs.stockEdit.open();
            this.$refs.stockForm.clear();
            this.$refs.stockForm.set({isStock: [1]});
            this.stockSearchHandle({isStock: [1]});
        },

        //查询云仓库存
        stockSearchHandle(data) {
            data.platform_user_id = this._setUserId;
            this.$refs.stockTable.load({
                url: '/cloud/stock/list',
                data
            });
        },
        //批量设置云仓库存
        batchSetStock() {
            let n = parseFloat(this.$refs.batchStockForm.serialize().value);
            if (n == n) {
                this.$refs.stockTable.getRow().forEach(item => {
                    item.data.revise_stock = n;
                })
            }
            this.$refs.batchStockForm.clear();
        },
        //提交云仓库存设置数据
        setStockHandle(stop) {
            stop();
            var stockList = this.$refs.stockTable.getRow().filter(item => ((parseInt(item.data.revise_stock) || 0) !=0));
            if(stockList.length ==0){
                this.$message({
                    text: '您未做任何库存变更！'
                });
                return;
            }
            this.request({
                url: '/cloud/stock/edit',
                data: {
                    platform_user_id: this._setUserId,
                    product_sku_stock_list: Array.from(stockList, item => {
                        return {
                            product_id: item.data.product_id,
                            product_sku: item.data.product_sku,
                            product_count: parseInt(item.data.product_count) + (parseInt(item.data.revise_stock) || 0)
                        }
                    })
                },
                loading: true,
                success: data => {
                    this.$message({
                        text: '云仓库存调整成功',
                        icon: 'success'
                    });
                    //刷新列表
                    this.$refs.stockTable.update();
                }
            });
        },
        /*************显示用户业绩明细列表**********/
        /**
         *
         * @param data      用户信息
         * @param state     业绩结算状态 0：取消清分、1：待清分，2：已经清分
         */
        showPerformanceRecord(data,state){
            var title = '会员【'+data.user_manage_mobilephone+'('+(data.nick_name||'--')+')】【'+(state==2?'已清分':'待清分')+'】业绩数据';
            this.$refs.userPerformanceRecord.open({
                platform_user_id:data.platform_user_id,
                states:[state],
                title:title
            });
        },

        /**同步导出数据*/
        syncExport(){
            var selectDatas = this.$refs.table.getRow('selected');
            var ids = [];
            if (selectDatas.length && selectDatas.length>0) {
                ids = Array.from(selectDatas, item => item.data.platform_user_id);
            }
            this.export(this.workType,this.searchParams,ids);
        }
    }
}
</script>